// Body of the California loadup (mattress pickup request) form: the
// capped-width account-form layout -- the SB 254 program copy, the
// pickup-request rules list, and the LoadUpOfferSubmitRequestForm rendered as a
// native React field tree (its pickup-quantity ChoiceFields are added
// dynamically per offer, so fields arrive serialized per-instance). Toppers has
// no loadup config, so this page upgrades the previously template-less
// (500-on-render) route to the shared React document.
import { Immutable } from "immer";
import React from "react";
import { FormFields } from "tsi-common-react/src/apps/customer-account/FormFields/index";
import {
    FORM_CLASS_NAME,
    FORM_FIELD_SUBMIT_CLASS_NAME,
} from "tsi-common-react/src/forms/classNames";
import { t } from "ttag";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

type IProps = Immutable<templates.LoadupRequestFormDocumentTemplate>;

export const LoadupRequestFormBody = (props: IProps): React.JSX.Element => (
    <div className="l-capped-width">
        <header>
            <h2>{t`Mattress Pickup Request`}</h2>
        </header>

        <div className="account-form">
            <p>{t`Thank you for your recent Tempur-Pedic purchase.`}</p>
            <p>
                {t`California's Used Mattress Recovery and Recycling Act (SB 254), amended with AB 187 requires all retailers that deliver a new mattress to a consumer in California to offer complimentary pick-up of their used mattress, if applicable.`}
            </p>
            <p>
                {t`If you'd like to take advantage of this offer, please complete the form below and you will be contacted within 1-3 business days to schedule an appointment.`}
            </p>
            <ul>
                <li>
                    {t`Pickup quantity can not exceed mattress order quantity.`}
                </li>
                <li>
                    {t`One mattress and flat foundation pick up request per form.`}
                </li>
                <li>{t`Your shipping address will be used for pick up.`}</li>
                <li>
                    {t`Mattress disposal is a separate service from delivery.`}
                </li>
                <li>{t`Pickup will be performed by a third-party vendor.`}</li>
            </ul>

            <form className={FORM_CLASS_NAME} method="post">
                <CSRFToken />
                <FormFields
                    fields={props.fields}
                    field_labels={props.field_labels}
                    field_errors={props.field_errors}
                    non_field_errors={props.non_field_errors}
                />
                <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                    <input
                        type="submit"
                        className="button button--full-width"
                        value={t`Submit`}
                    />
                </div>
            </form>
        </div>
    </div>
);
